module.exports = "<div v-if=\"isActive\">\n  <slot></slot>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/phase-wrapper/index.html
// module id = D8Ro
// module chunks = 1